import script from "./TimeWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeWidget.vue?vue&type=script&setup=true&lang=js"

import "./TimeWidget.vue?vue&type=style&index=0&id=fb0977c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb0977c0"]])

export default __exports__